import { render, staticRenderFns } from "./PrevOrdersBlock.vue?vue&type=template&id=59234918&"
import script from "./PrevOrdersBlock.vue?vue&type=script&lang=js&"
export * from "./PrevOrdersBlock.vue?vue&type=script&lang=js&"
import style0 from "./PrevOrdersBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports